<template>
  <div class="teaching-evaluate-apply-common"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="commonQuotas">
      <div class="quota">
        <div class="header">
          <div class="title">
            <span>评教指标</span>
          </div>
          <div class="extra">
            <TeachingEvaluateApplyCommonQuotaAdd :evaluation="evaluation"
                                                 @add-success="onQuotaAddSuccess">
              <template #default="{toggleVisible}">
                <el-button size="mini"
                           type="text"
                           @click="toggleVisible">添加</el-button>
              </template>
            </TeachingEvaluateApplyCommonQuotaAdd>
          </div>
        </div>
        <div class="body">
          <div class="body-cont">
            <AppScrollbar v-if="commonQuotas.length"
                          style="height: 100%">
              <div class="quota-main">
                <Draggable class="quota-list"
                           v-model="commonQuotas"
                           v-bind="quotaDndOptions"
                           @end="onDragQuota">
                  <div v-for="commonQuota in commonQuotas"
                       :key="commonQuota.id"
                       :class="['quota-item theme-text-active theme-text-hover theme-light-bg-active', {'is-active': commonQuota === current}]"
                       :title="commonQuota.label"
                       @click="onClickQuota(commonQuota)">
                    <div class="holder">
                      <i class="el-icon-more"></i>
                    </div>
                    <div class="label">{{commonQuota.label}}</div>
                    <div class="extra"
                         @click.stop>
                      <TeachingEvaluateApplyCommonQuotaUpdate :evaluation="evaluation"
                                                              :common-quota="commonQuota">
                        <template #default="{toggleVisible}">
                          <el-button size="mini"
                                     type="text"
                                     icon="el-icon-edit"
                                     :disabled="commonQuota.deleting"
                                     @click="toggleVisible"></el-button>
                        </template>
                      </TeachingEvaluateApplyCommonQuotaUpdate>
                      <el-button class="btn-delete"
                                 size="mini"
                                 type="text"
                                 icon="el-icon-delete"
                                 :disabled="commonQuota.deleting"
                                 @click="onDeleteQuota(commonQuota)"></el-button>
                    </div>
                  </div>
                </Draggable>
              </div>
            </AppScrollbar>
            <Hint v-else
                  :icon="false">
              <span>暂无评教指标</span>
            </Hint>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="main-cont">
          <template v-if="current">
            <TeachingEvaluateApplyCommonMain :key="current.id"
                                             :evaluation="evaluation"
                                             :common-quota="current"></TeachingEvaluateApplyCommonMain>
          </template>
          <template v-else>
            <Hint>
              <span>请选择评教指标</span>
            </Hint>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>评教指标数据加载失败</div>
        <el-button type="text"
                   @click="loadCommonQuotas">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import TeachingEvaluateApplyCommonQuotaAdd from './quota-add'
import TeachingEvaluateApplyCommonQuotaUpdate from './quota-update'
import TeachingEvaluateApplyCommonMain from './main'
import Hint from '../../../../../../../elements/Hint'
import Draggable from 'vuedraggable'
export default {
  name: 'TeachingEvaluateApplyCommon',
  components: {
    AppScrollbar,
    TeachingEvaluateApplyCommonQuotaAdd,
    TeachingEvaluateApplyCommonQuotaUpdate,
    TeachingEvaluateApplyCommonMain,
    Hint,
    Draggable
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      commonQuotas: null,
      current: null,
      quotaDndOptions: {
        handle: '.quota-item .holder',
        animation: 300
      }
    }
  },
  methods: {
    loadCommonQuotas () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/common/quotas',
        method: 'post',
        data: this.$qs.stringify({
          id: this.evaluation.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.commonQuotas = response.data['commonQuotas'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    onQuotaAddSuccess (commonQuota) {
      if (this.commonQuotas) {
        this.commonQuotas.push(commonQuota)
      } else {
        this.loadCommonQuotas()
      }
    },
    onDeleteQuota (commonQuota) {
      this.$confirm(`确定要删除“${commonQuota.label}”评教指标吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(commonQuota, 'deleting', true)
        this.$ajax({
          url: '/workspace/manager/teaching/evaluate/apply/common/deleteQuota',
          method: 'post',
          data: this.$qs.stringify({
            id: this.evaluation.id,
            quotaId: commonQuota.id
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                let commonQuotas = this.commonQuotas
                if (commonQuotas) {
                  let index = commonQuotas.findIndex(item => item.id === commonQuota.id)
                  if (index >= 0) {
                    commonQuotas.splice(index, 1)
                  }
                }
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.$delete(commonQuota, 'deleting')
        })
      }).catch(() => {})
    },
    onClickQuota (commonQuota) {
      this.current = commonQuota
    },
    onDragQuota () {
      if (this.commonQuotas) {
        this.$nextTick(() => {
          this.$ajax({
            url: '/workspace/manager/teaching/evaluate/apply/common/sortQuota',
            method: 'post',
            data: this.$qs.stringify({
              id: this.evaluation.id,
              quotaIds: this.commonQuotas.map(item => item.id)
            }, {
              arrayFormat: 'repeat'
            })
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          })
        })
      }
    }
  },
  mounted () {
    this.loadCommonQuotas()
  },
  watch: {
    commonQuotas: function (val) {
      if (this.current) {
        if (val) {
          let getCurrent = val.find(item => item.id === this.current.id)
          if (getCurrent) {
            this.current = getCurrent
          } else {
            this.current = val[0]
          }
        } else {
          this.current = null
        }
      } else {
        if (val) {
          this.current = val[0]
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../styles/color";
  .teaching-evaluate-apply-common {
    position: relative;
    height: 100%;
    display: flex;
    align-items: stretch;
    & > .quota {
      flex: none;
      width: 240px;
      border-right: 1px solid #ebeef5;
      display: flex;
      flex-direction: column;
      & > .header {
        flex: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 9px 10px 9px 20px;
        & > .title {
          color: #909399;
          font-size: 12px;
        }
      }
      & > .body {
        flex: auto;
        position: relative;
        & > .body-cont {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          .quota-main {
            & > .quota-list {
              .quota-item {
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 4px 10px 4px 20px;
                cursor: pointer;
                transition: all .3s;
                & > .holder {
                  position: absolute;
                  left: 5px;
                  top: 50%;
                  width: 14px;
                  height: 14px;
                  text-align: center;
                  line-height: 14px;
                  transform: translateY(-50%);
                  margin-top: 1px;
                  cursor: move;
                  opacity: 0;
                  transition: all .3s;
                  i {
                    display: block;
                    margin-right: 0!important;
                    color: #909399;
                    font-size: 12px;
                    transform: scale(.9) rotate(90deg);
                  }
                }
                & > .label {
                  flex: auto;
                  font-size: 12px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                & > .extra {
                  flex: none;
                  margin-left: 10px;
                  opacity: 0;
                  transition: all .3s;
                  .el-button {
                    margin-left: 5px;
                    &.btn-delete {
                      color: $set-danger-color;
                    }
                  }
                }
                &:hover {
                  & > .holder,
                  & > .extra {
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
    .layout-hint {
      width: 100%;
    }
  }
</style>
